export interface OrganizationAttribute {
  attributeSource: 'Custom' | 'Standard';
  isProtectedType: boolean;
  attributeName: string;
  mappedName: string;
  attributeDataType: 'string' | 'number' | 'datetime' | 'bool';
  attributeId: number;
  attributeFeatures: FeatureSet[];
  id: string; // needed for ELF store, added manually.  Combination of attributeId and attributeSource
}

export interface FeatureSet {
  featureName: string;
  isVisible: boolean;
  isSupported: boolean;
}

export interface GetOrganizationAttributesResponse {
  total: number;
  attributes: OrganizationAttribute[];
}

export enum AttributeDataType {
  String = 'string',
  Number = 'number',
  DateTime = 'datetime',
  Bool = 'bool',
}

export interface Attribute {
  attributeName: string;
  attributeDataType?: AttributeDataType;
}

export interface FileFieldMapping {
  defaultFieldName: string;
  organizationCustomFieldName?: string; // This will only be defined if it differs from defaultFieldName
}

export const enum StaticAttributes {
  APPLY_TO_NEW_USERS = 'ApplyToNewUsers',
  APPLY_TO_ALL_USERS = 'ApplyToAllUsers',
}
